module.exports = __webpack_public_path__ + "img/work2019SLens.b883b454.png";